import { useState, useEffect, useRef } from 'react'
import { useOptionalSaveStateContext } from '../../useSaveStateContext'

interface SaveStatus {
  isSaving: boolean
  showIndicator: boolean
}

/** Combines SaveStateContext with a 3-second "Saved" flash after save completes */
export const useSaveStatus = (
  isSavingProp: boolean,
  lastSavedProp: Date | null | undefined
): SaveStatus => {
  const saveStateContext = useOptionalSaveStateContext()
  const isSaving = saveStateContext?.isSaving ?? isSavingProp
  const lastSaved = saveStateContext?.lastSaved ?? lastSavedProp ?? null

  const [showSaved, setShowSaved] = useState(false)
  const lastSavedRef = useRef<Date | null>(null)

  useEffect(() => {
    if (lastSaved && lastSaved !== lastSavedRef.current) {
      lastSavedRef.current = lastSaved
      setShowSaved(true)
      const timer = setTimeout(() => setShowSaved(false), 3000)
      return () => clearTimeout(timer)
    }
    return undefined
  }, [lastSaved])

  return {
    isSaving,
    showIndicator: isSaving || showSaved,
  }
}
